import actionTypes from './action-types';
import { terUtilsDraftLoadVersion1Helper, terUtilsDeleteDraftelHelper, terUtilsCreateKlimaKomoraHelper, terUtilsCreateModulHelper, terUtilsCreatePoluproizvodHelper, terUtilsCreateMaterijalCustomHelper, terUtilsUpdateKlimaKomoraHelper, terUtilsUpdateModulHelper, terUtilsUpdatePoluproizvodHelper, terUtilsUpdateKlimaKomoraPozicijaModulaHelper, terUtilsVr2DraftLoadHelper, terUtilsDraftAfterSaveToDatabaseSuccessHelper, terUtilsDraftUnloadHelper, terUtilsDraftLoadBlankHelper, terUtilsUpdateSmartelEnabled, terUtilsDraftLoadImportedSmartbomFromCapsule, terUtilsDraftLoadVersion2Helper, terUtilsDraftRefreshSmartbom, terUtilsDraftLoadHelper_virbom_is_blank, terUtilsUpsertSmartelSelfProperty, terUtilsCreateMaterijalCustomBulkHelper, } from '../ter/ter-reactive-utils';
import { terSuperValidatorAllHelper } from '../ter/ter-super-validator-lib';
// import { _datarender_vr_draft_by_draftel_arr } from '../ter/ter-virtel-datarender-by-draftel-arr'; // OBSOLETE
import { reducer_res_create, reducer_res_response_write } from '../utils/reducer-res-utils';
import { _smartbom_manipulator_init_make_smartbom } from '../utils/frfr-smartbom-utils';
import { _datarender_virbom_from_smartbom } from '../ter/ter-virbom-datarender';
import { _make_sastavnica_internal_from_virbom_seq } from '../ter/ter-export-lib-sastavnica-21r3';
import { terUtils_make_smartbom_manifest_terkk_latest } from '../ter/ter-smartbom-utils';
import { _getTerkkCparamsDefaultFromLib } from '../ter/ter-params-utils';


/*
const initialDraftZaglavlje_STARO = {
  readme: 'Ovo je draft zaglavlje koje ukljucuje relaciju na nosioca troska i meta podatke od projekta',
  id: "1",
  nosilactroska: "",
  nazivprojekta: ""
};
const initialDraftZaglavlje = {
  readme: 'Ovo je draft zaglavlje koje ukljucuje relaciju na nosioca troska i meta podatke od projekta. ID je superid tj. ID projekta ucitanog iz baze',
  id: null,
  nazivprojekta: null,
};
const initial_virbom_header = {
  readme: 'Ovo je draft zaglavlje koje ukljucuje relaciju na nosioca troska i meta podatke od projekta. ID je superid tj. ID projekta ucitanog iz baze',
  id: null,
  virbom_parent_id: null
};
*/

/*
TODO treba srediti kako tacno cuvamo virbom_header projekta u draftu?
*/
// kk, mm, pp i verovatno zaglavlje se cuvaju u bazi...
const initialState = {
  loading: false, // virbom editor spinner
  loaded: false,
  saved: true,
  saving: false,

  virbom_header: false, // 2023-01-10
  virbom_header_db: false, // 2023-01-10

  /*
  smartbom: {
    ..._smartbom_manipulator_init_make_smartbom(terUtils_make_smartbom_manifest_terkk_latest(), null)
  },
  */
  draftel_arr: [],
  kk: [],
  mm: [],
  pp: [],
  virbom_seq: [], // TODO
  virtel_with_genus_ident_arr: null,
  sastavnica_internal: [],
  freshness: 0,
  superValidacija: {},
  zaSupervalidatorDimenzijeModulaIzmenjene: 0,
  wizardInfo: {
    operationFreshness: 0,
    operationCreatedId: false
  },
  reducerResponses: {
    counter: 0,
    includedKeys: [], // arraay of keys for fast checking is there a response for particular request key
    items: []
  }
};

const _initialState_make = () => {
  const default_smartbom_cparams = _getTerkkCparamsDefaultFromLib();
  return {
    ...initialState,
    smartbom: _smartbom_manipulator_init_make_smartbom(terUtils_make_smartbom_manifest_terkk_latest(), default_smartbom_cparams)
  };
};

/*
DOKUMENTACIJA:
n je jedan npsilacTroska (pre je bio array nn ali sada je sam ojedan)
kk klimaKomore
mm moduli
pp poluproizvodi
*/


//
const _enrich_with_virbom_seq = (draft) => {
  // add virbom_seq to redux state
  console.log('_enrich_with_virbom_seq(draft)');
  const old_mode = false;
  if (old_mode) {
    // OLD MODE
    //
  } else {
    // NOVO 2023 MAJ
    const virbom_seq = _datarender_virbom_from_smartbom(draft.smartbom);
    let virbom_rev_id = null;
    if (draft.virbom_header && draft.virbom_header.id) {
      virbom_rev_id = draft.virbom_header.id;
    }
    const sastavnica_internal = _make_sastavnica_internal_from_virbom_seq(virbom_seq, virbom_rev_id);
    return {
      ...draft,
      virbom_seq,
      sastavnica_internal
    };
  }
};


//
const draftReducer = (state = initialState, action) => {
  switch (action.type) {

    case actionTypes.DRAFT_REDUCER_RESPONSE_CREATE:
      const reducer_res_key = action.payload;
      return {
        ...state,
        reducerResponses: reducer_res_response_write(reducer_res_key, state.reducerResponses)
      }

    case actionTypes.DRAFT_UNLOAD:
      return terUtilsDraftUnloadHelper(_initialState_make());

    case actionTypes.DRAFT_LOAD_BLANK:
      return terUtilsDraftLoadBlankHelper(_initialState_make()); // drugi argument je objekat sa kompletnim virbom-om iz baze

    case actionTypes.DRAFT_LOAD:
      const resbox = action.payload;
      console.log('draft-reducer DRAFT_LOAD - resbox', resbox);
      if (resbox.version === 2) {
        // CASE virbom_resbox version 2
        console.log('TEST resbox.version === 2', resbox.version === 2);
        // TODO
        return terUtilsDraftLoadVersion2Helper(state, resbox); // TODO
      } else {
        // CASE virbom_resbox version OLD
        console.log('TEST virbom_resbox version OLD');
        return terUtilsDraftLoadVersion1Helper(state, resbox); // drugi argument je objekat sa kompletnim virbom-om iz baze
      }

    case actionTypes.DRAFT_LOAD_VIRBOM_IS_BLANK:
      const resbox1 = action.payload;
      console.log('draft-reducer DRAFT_LOAD_VIRBOM_IS_BLANK - resbox', resbox1);
      // CASE virbom_resbox virbom_is_blank
      console.log('TEST virbom_resbox version OLD');
      return terUtilsDraftLoadHelper_virbom_is_blank(state, resbox1); // drugi argument je objekat sa kompletnim virbom-om iz baze

    case actionTypes.DRAFT_LOAD_IMPORTED_SMARTBOM:
      // return terUtilsDraftLoadImportedDraftelArr(state, action.payload); // drugi argument je draftel_arr poreklom importovan iz fajla
      return terUtilsDraftLoadImportedSmartbomFromCapsule(state, action.payload.smartbom); // drugi i treci argument su poreklom importovan iz fajla

    case actionTypes.DRAFT_REFRESH_SMARTBOM:
      //
      return terUtilsDraftRefreshSmartbom(state); //

    case actionTypes.DRAFT_SAVETODB_FETCHING:
      return state;

    case actionTypes.DRAFT_SAVETODB_SUCCESS:
      return terUtilsDraftAfterSaveToDatabaseSuccessHelper(state, action);

    case actionTypes.DRAFT_SAVETODB_FAIL:
      return {
        ...state,
        saving: true
      };

    case actionTypes.DRAFT_KLIMA_KOMORA_DODAJ:
      return _enrich_with_virbom_seq(terUtilsCreateKlimaKomoraHelper(state, action.payload.entbox, action.payload.parent_subkey, action.payload.wizardMode, action.payload.wizardOperationFreshness));

    case actionTypes.DRAFT_KLIMA_KOMORA_IZMENI:
      return _enrich_with_virbom_seq(terUtilsUpdateKlimaKomoraHelper(state, action.payload.entbox, action.payload.subkey));

    /*
      case actionTypes.DRAFT_KLIMA_KOMORA_DUPLIRAJ:
      return _enrich_with_virbom_seq(terUtilsDuplicateKlimaKomoraHelper(state, action.payload.entbox));
      */

    case actionTypes.DRAFT_KLIMA_KOMORA_OBRISI:
      return _enrich_with_virbom_seq(terUtilsDeleteDraftelHelper(state, action.payload));

    case actionTypes.DRAFT_MODUL_DODAJ:
      return _enrich_with_virbom_seq(terUtilsCreateModulHelper(state, action.payload.entbox, action.payload.parent_subkey, action.payload.wizardMode, action.payload.wizardOperationFreshness));

    case actionTypes.DRAFT_MODUL_IZMENI:
      return _enrich_with_virbom_seq(terUtilsUpdateModulHelper(state, action.payload.entbox, action.payload.subkey, action.payload.wizardMode, action.payload.wizardOperationFreshness));

    /*
    case actionTypes.DRAFT_MODUL_DUPLIRAJ:
      return _enrich_with_virbom_seq(terUtilsDuplicateModulHelper(state, action.payload.entbox));
      */

    case actionTypes.DRAFT_MODUL_OBRISI:
      return _enrich_with_virbom_seq(terUtilsDeleteDraftelHelper(state, action.payload));

    case actionTypes.DRAFT_POLUPROIZVOD_DODAJ:
      return _enrich_with_virbom_seq(terUtilsCreatePoluproizvodHelper(state, action.payload.entbox, action.payload.parent_subkey, action.payload.wizardMode, action.payload.wizardOperationFreshness));

    case actionTypes.DRAFT_POLUPROIZVOD_IZMENI:
      return _enrich_with_virbom_seq(terUtilsUpdatePoluproizvodHelper(state, action.payload.entbox, action.payload.subkey));

    /*
    case actionTypes.DRAFT_POLUPROIZVOD_DUPLIRAJ:
      return _enrich_with_virbom_seq(terUtilsDuplicatePoluproizvodHelper(state, action.payload.entbox));
      */

    case actionTypes.DRAFT_POLUPROIZVOD_OBRISI:
      return _enrich_with_virbom_seq(terUtilsDeleteDraftelHelper(state, action.payload));

    case actionTypes.DRAFT_MATERIJALCUSTOM_DODAJ:
      return _enrich_with_virbom_seq(terUtilsCreateMaterijalCustomHelper(state, action.payload.entbox, action.payload.parent_subkey, action.payload.wizardMode, action.payload.wizardOperationFreshness));

    case actionTypes.DRAFT_MATERIJALCUSTOM_DODAJ_BULK:
      return _enrich_with_virbom_seq(terUtilsCreateMaterijalCustomBulkHelper(state, action.payload.entbox, action.payload.parent_subkey));


    case actionTypes.DRAFT_SMARTEL_ENABLE:
      return _enrich_with_virbom_seq(terUtilsUpdateSmartelEnabled(state, action.payload.enabled, action.payload.subkey));


    case actionTypes.DRAFT_SMARTEL_CPARAMS_OWN_UPSERT:
      return _enrich_with_virbom_seq(terUtilsUpsertSmartelSelfProperty(state, action.payload.keyVal, action.payload.subkey));


    case actionTypes.DRAFT_SUPERVALIDATOR_ALL:
      // return _enrich_with_virbom_seq(terSuperValidatorAllHelper(state, action.payload));
      return terSuperValidatorAllHelper(state, action.payload);

    case actionTypes.DRAFT_CLICKED_POZICIONIRAJ_MODUL_WIDGET:
      return _enrich_with_virbom_seq(terUtilsUpdateKlimaKomoraPozicijaModulaHelper(state, action.payload));


    default:
      console.log('draft-reducer switch default - action.type', action.type);
      return state;
  }
};

export default draftReducer;